import { contrastChart } from '@iq/react-components';
import { resolveColor } from '../../../../../../colors';

export default function RollingAveragePlot({ rollingData, configuration, vizSize, scale }) {
  return (
    <g>
      <g
        name="rolling-plot"
        style={{ pointerEvents: 'none' }}
      >
        {rollingData.length > 0 &&
          rollingData.map((value, index) => {
            if (index === rollingData.length - 1) {
              return null;
            }
            if (configuration.rollingAverage?.type === 'Lines') {
              return (
                <line
                  key={index}
                  x1={vizSize / 2 + value.X * scale}
                  y1={vizSize / 2 + value.Y * scale}
                  x2={vizSize / 2 + rollingData[index + 1].X * scale}
                  y2={vizSize / 2 + rollingData[index + 1].Y * scale}
                  stroke={resolveColor(configuration.rollingAverage?.color) || contrastChart[1]}
                  strokeWidth={configuration.pointRadius / 3}
                  opacity={((100 / rollingData.length) * index) / 100}
                />
              );
            }
            if (configuration.rollingAverage?.type === 'Both') {
              return (
                <g key={index}>
                  <line
                    x1={vizSize / 2 + value.X * scale}
                    y1={vizSize / 2 + value.Y * scale}
                    x2={vizSize / 2 + rollingData[index + 1].X * scale}
                    y2={vizSize / 2 + rollingData[index + 1].Y * scale}
                    stroke={resolveColor(configuration.rollingAverage?.color) || contrastChart[1]}
                    strokeWidth={configuration.pointRadius / 3}
                    opacity={((100 / rollingData.length) * index) / 100}
                  />
                  <circle
                    cx={vizSize / 2 + value.X * scale}
                    cy={vizSize / 2 + value.Y * scale}
                    r={configuration.pointRadius / 2}
                    opacity={((100 / rollingData.length) * index) / 100}
                    fill={resolveColor(configuration.rollingAverage?.color) || contrastChart[1]}
                    stroke=""
                  />
                </g>
              );
            }
            return (
              <circle
                key={index}
                cx={vizSize / 2 + value.X * scale}
                cy={vizSize / 2 + value.Y * scale}
                r={configuration.pointRadius / 2}
                opacity={((100 / rollingData.length) * index) / 100}
                fill={resolveColor(configuration.rollingAverage?.color) || contrastChart[1]}
                stroke=""
              />
            );
          })}
      </g>
    </g>
  );
}
